/**
 * Interprets the result of `NativeSettings.open()` across native-plugin versions.
 *
 * The `capacitor-native-settings` native return shape changed from
 * `{ success: boolean }` (v8.0.0, shipped in app builds <= 1.2.3) to
 * `{ status: boolean }` (v8.1.0+). When a newer JS bundle is delivered via OTA
 * to an older native binary, only the legacy `success` field is present.
 *
 * Treats the call as failed only when the plugin explicitly reports failure via
 * either field, so an old binary that omits `status` is not misreported as a
 * failure (which would generate false-positive telemetry).
 */
export const didOpenNativeSettings = (result: { status?: boolean }): boolean => {
  const legacySuccess = (result as { success?: boolean }).success;
  return result.status ?? legacySuccess ?? true;
};
